<app-modal-wrapper
  [title]="readOnly ? 'View Group' : (id ? 'Edit Group' : 'New Group')"
  (closeRequest)="close()"
>
  <div
    *ngIf="readOnly"
    class="text-sm text-indigo-700 bg-indigo-50 border border-indigo-100 rounded-md px-3 py-2 mb-4"
  >
    This is a system group and cannot be edited.
  </div>

  <div class="flex flex-col gap-2">
    <label class="text-sm font-medium text-gray-700">Group Name</label>
    <input
      type="text"
      class="w-full border border-gray-300 rounded-md px-3 py-2"
      [(ngModel)]="name"
      [disabled]="readOnly"
      placeholder="Type a group name"
    />
  </div>

  <app-role-picker
    class="mt-4 block"
    [availableItems]="availablePermissions"
    [selectedItems]="selectedPermissions"
    [displayField]="'label'"
    [idField]="'name'"
    [allowBulkSearch]="true"
  ></app-role-picker>

  <div modalFooter class="flex items-center gap-3">
    <button
      pButton
      type="button"
      [label]="readOnly ? 'Close' : 'Cancel'"
      class="p-button-text font-bold text-sm text-gray-600 px-6 py-3"
      (click)="close()"
    ></button>
    <button
      *ngIf="!readOnly"
      pButton
      type="button"
      label="Save"
      icon="pi pi-save"
      iconPos="right"
      class="font-bold border-none text-sm shadow-sm transition-all px-8 py-3"
      [style]="{
        'background-color': !name || !name.trim() ? '#cbd5e1' : 'var(--primary-500)',
        'color': '#ffffff',
        'cursor': !name || !name.trim() ? 'not-allowed' : 'pointer'
      }"
      [disabled]="!name || !name.trim()"
      (click)="save()"
    ></button>
  </div>
</app-modal-wrapper>
